import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, of } from 'rxjs';

export interface UpdateMerchantRequest {
  Name?: string;
  BasePrice?: number;
  PerSmsprice?: number;
  SalesRepresentativeId?: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class MerchantService extends BaseApiService {
  private readonly merchantEndpoint = `/v2/Merchants`;
  findAll(coalitionId: number) {
    return this.get(`${this.merchantEndpoint}`, {
      coalitionId: coalitionId,
    }).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  findById(merchantId: number) {
    return this.get(`${this.merchantEndpoint}/${merchantId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  update(merchantId: number, updateMerchantRequest: UpdateMerchantRequest) {
    return this.patch(`${this.merchantEndpoint}/${merchantId}`, updateMerchantRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  findAccessByMerchantId(merchantId: number) {
    return this.get(`${this.merchantEndpoint}/${merchantId}/access`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
